import veraAPI from "../apis/localTesting";
import convert from "xml-js";
import { getSupplierInfo, getOptionInfo } from "./iresXML";

export const iresOptionInfo = async (optCode) => {
  let response = null;
  let xml = getOptionInfo(optCode);
  //console.log(xml);

  response = await veraAPI
    .post("book/rawXML", {
      providers: ["iresXML"],
      agent: "VIVB2C",
      password: "lovethatvivafeeling",
      applicationId: "vivaconsumer",
      xmlMsg: xml,
    })
    .catch((err) => {
      response = err;
    });

  if (response) {
    let xmlReply = convert.xml2js(response.data, {
      compact: true,
      spaces: 4,
    });

    console.log(xmlReply);
  }
};

export const iresSupplierInfo = async (type, supplier) => {
  let response = null;
  let xml = getSupplierInfo(type, supplier);
  //console.log(xml);

  response = await veraAPI
    .post("book/rawXML", {
      providers: ["iresXML"],
      agent: "VIVB2C",
      password: "lovethatvivafeeling",
      applicationId: "vivaconsumer",
      xmlMsg: xml,
    })
    .catch((err) => {
      response = err;
    });

  if (response) {
    let xmlReply = convert.xml2js(response.data, {
      compact: true,
      spaces: 4,
    });

    console.log(xmlReply);
  }
};
